import { render, staticRenderFns } from "./orderGtxyList.vue?vue&type=template&id=04462ab5&scoped=true"
import script from "./orderGtxyList.vue?vue&type=script&lang=js"
export * from "./orderGtxyList.vue?vue&type=script&lang=js"
import style0 from "./orderGtxyList.vue?vue&type=style&index=0&id=04462ab5&prod&scoped=true&lang=css"
import style1 from "./orderGtxyList.vue?vue&type=style&index=1&id=04462ab5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04462ab5",
  null
  
)

export default component.exports